/**
 * Game-related types
 */

export enum GameId {
  TileClicker = 'tile-clicker',
  BanterBattle = 'witocracy',
  Taptionary = 'word-drift',
  GrowGrowTomato = 'grow-grow-tomato',
  Craftegory = 'craftegory',
  AnalogyAscent = 'analogy-ascent',
  // Add additional game IDs as needed.
}

export enum GameType {
  Unity = 'unity',
  React = 'React'
}

export enum LaunchStatus {
  UNANNOUNCED = "unannounced",
  ANNOUNCED = "announced",
  RELEASED = "released"
}

export interface GameMetadata {
  gameId: string;
  gameName: string;
  gameDescription: string;
  gameURL: string;
  gameType: GameType;
  launchStatus: LaunchStatus;
  gameIcon?: string; // Icon URL for emails and UI
}

export interface Game {
  gameId: GameId;
  metadata: GameMetadata;
  colorPrimary: string;
  colorSecondary: string;
  fontPrimary: string;
  fontSecondary: string;
  titleArt: string;
  gameIconLarge: string;
  howToPlayGif?: string;
  howToPlayText?: string;
}
